(ns io.daskul.webapp.widgets.dashboard.date-range
  "Date range selector for dashboard analytics sections."
  (:require
   [uix.core :refer [defui $ use-callback use-state]]
   [uix.re-frame :as urf]
   [re-frame.core :as rf]
   [io.daskul.webapp.ui :as ui]
   [io.daskul.webapp.widgets.dashboard.dates :as dates]
   [io.daskul.webapp.widgets.dashboard.events :as dashboard.events]
   [io.daskul.webapp.widgets.dashboard.subs :as dashboard.subs]))

(def ^:private presets
  #js [#js {:value "this-week"    :label "This Week"}
       #js {:value "this-month"   :label "This Month"}
       #js {:value "last-30-days" :label "Last 30 Days"}
       #js {:value "last-90-days" :label "Last 90 Days"}
       #js {:value "this-year"    :label "This Year"}
       #js {:value "custom"       :label "Custom Range"}])

(defui custom-range-fields
  "From / To / Apply, seeded from the range currently applied (#749).

   Its own component so the seeding happens on mount — which is exactly when
   the user switches to Custom Range, and again if the page remounts. The
   fields previously started at nil with no way back to the applied range, so
   Apply appeared to erase what it had just applied.

   Still held in local state, not app-db: a half-entered range (From set, To
   not) is not something to fetch. Only Apply commits."
  [{:keys [start-date end-date]}]
  (let [[custom-start set-custom-start!] (use-state (dates/parse-date start-date))
        [custom-end   set-custom-end!]   (use-state (dates/parse-date end-date))
        on-apply (use-callback
                  (fn []
                    (when (and custom-start custom-end)
                      (rf/dispatch [::dashboard.events/set-custom-date-range
                                    (dates/format-date custom-start)
                                    (dates/format-date custom-end)])))
                  [custom-start custom-end])]
    ($ ui/group {:gap "sm" :align "flex-end"}
      ($ ui/date-input
        {:label       "From"
         :size        "sm"
         :value       custom-start
         :onChange    set-custom-start!
         :valueFormat "YYYY-MM-DD"
         :maxDate     (or custom-end (js/Date.))
         :clearable   true
         :style       #js {:maxWidth 160}})
      ($ ui/date-input
        {:label       "To"
         :size        "sm"
         :value       custom-end
         :onChange    set-custom-end!
         :valueFormat "YYYY-MM-DD"
         :minDate     custom-start
         :maxDate     (js/Date.)
         :clearable   true
         :style       #js {:maxWidth 160}})
      ($ ui/button
        {:size     "sm"
         :onClick  on-apply
         :disabled (not (and custom-start custom-end))}
        "Apply"))))

(defui date-range-selector
  "Dropdown selector with presets + custom date picker."
  []
  (let [date-range (urf/use-subscribe [::dashboard.subs/date-range])
        preset     (or (:preset date-range) "this-month")
        on-change  (use-callback
                    (fn [value]
                      (if (= value "custom")
                        (rf/dispatch [::dashboard.events/set-custom-mode])
                        (rf/dispatch [::dashboard.events/set-date-range value])))
                    [])]
    ($ ui/group {:gap "sm" :align "flex-end" :wrap "wrap"}
      ($ ui/select
        {:data        presets
         :value       preset
         :onChange    on-change
         :size        "sm"
         :allowDeselect false
         :style       #js {:maxWidth 200}})
      (when (= preset "custom")
        ($ custom-range-fields
           {:start-date (:start-date date-range)
            :end-date   (:end-date date-range)})))))
